module.exports = __webpack_public_path__ + "media/images/bg/headers/course-2b5568c12880cb1139e085c0b016d962.jpg";